import { FC } from 'react';
import { Icon } from 'src/components/index';
import { Scenario } from 'src/api/userScenario/types';
import { useUserContext } from 'src/context/user';
import * as S from './styles';

interface Props {
  scenario: Scenario;
  onClickDetails?: () => void;
  isWide?: boolean;
}

interface SubComponents {
  LoadingSkeleton: typeof S.LoadingSkeleton;
  loadingSkeletonWidthInPx: typeof S.loadingSkeletonWidthInPx;
}

export const ScenarioCard: FC<Props> & SubComponents = ({ scenario, onClickDetails, isWide }) => {
  const { user } = useUserContext();

  const isCompleted = scenario?.progress?.progressPercent === 100;
  const showLock = scenario?.isPremium && scenario?.isLocked && !isCompleted;

  return (
    <S.ProgressCard
      data-testid="ScenarioCard-Wrapper"
      $isPremium={scenario?.isPremium && !user?.isPro}
      $isCompleted={isCompleted}
      onClick={onClickDetails}
      $isWide={isWide}
    >
      <S.ContentWrapper>
        {scenario?.photoUrl && (
          <S.Photo
            src={scenario.photoUrl}
            alt=""
            $isCompleted={isCompleted}
            data-testid="ScenarioCard-Photo"
          />
        )}
        {showLock && (
          <S.IconWrapper>
            <Icon name="padlockGradient" />
          </S.IconWrapper>
        )}
        <S.Title dir="auto">{scenario?.title}</S.Title>
      </S.ContentWrapper>
    </S.ProgressCard>
  );
};

ScenarioCard.LoadingSkeleton = S.LoadingSkeleton;
ScenarioCard.loadingSkeletonWidthInPx = S.loadingSkeletonWidthInPx;
